module.exports = __webpack_public_path__ + "img/account-icon-dark.cdf961dd.svg";